export default "https://cdn-web.disco.co/blank-experience-template-cover-afcbd03f5426611cdf41b81c92a67def.png";